import HttpService from './http-service';
import EdudoResponse from '../models/edudo-response';

const getFormatedStudentData = (data: ManagementStudentData) => {
  const newData = {
    name: data.studentName,
    classroomId: data.studentClassroom,
    gender: data.studentGender,
    responsibles: [
      {
        name: data.firstResponsibleName,
        phone: data.firstResponsiblePhone.replace(/\D+/g, ''),
        email: data.firstResponsibleEmail
      }
    ]
  };

  if (data.secondResponsibleName && data.secondResponsiblePhone) {
    newData.responsibles.push({
      name: data.secondResponsibleName,
      phone: data.secondResponsiblePhone.replace(/\D+/g, ''),
      email: data.secondResponsibleEmail
    })
  }

  return newData;
};

export default class ManagementService {
  async getClassrooms(): Promise<Classroom[]> {
    const response = await HttpService.getJson<EdudoResponse<Classroom[]>>(
      '/v1/Classrooms/List'
    );

    return response.data;
  }

  async getClassroom(classroomId: number): Promise<ClassroomStudents> {
    const response = await HttpService.getJson<EdudoResponse<ClassroomStudents>>(
      `/v1/Classrooms/ClassroomWithStudents?id=${classroomId}`
    );

    return response.data;
  }

  async getEmployees(): Promise<Employee[]> {
    const response = await HttpService.getJson<EdudoResponse<Employee[]>>(
      '/v1/Employees/List'
    );

    return response.data;
  }
  
  async getEmployee(employeeId: number) {
    const response = await HttpService.getJson<EdudoResponse<Employee>>(
        `/v1/Employees/${employeeId}`
    );

    return response.data; 
  }

  createNewClassroom(data: CreateClassroomFormData) {
    return HttpService.postJson('/v1/Classrooms', data);
  }

  updateClassroom(data: CreateClassroomFormData, classroomId: number) {
    const newData = Object.assign({}, data);
    delete newData['id'];

    return HttpService.putJson(`/v1/Classrooms/${classroomId}`, newData);
  }

  createNewEmployee(data: CreateEmployeeFormData) {
    const newData = Object.assign({}, data);
    delete newData['id'];

    return HttpService.postJson('/v1/Employees', newData);
  }

  updateEmployee(data: CreateEmployeeFormData, employeeId: number) {
    const newData = Object.assign({}, data);

    for (const [key, value] of Object.entries(newData)) {
      if (!value) delete newData[key];
    }

    delete newData['id'];

    return HttpService.patchJson(`/v1/Employees/${employeeId}`, newData);
  }

  deleteClassroom(id: number) {
    return HttpService.delete(`/v1/Classrooms/${id}`);
  }

  deleteEmployee(id: number) {
    return HttpService.delete(`/v1/Employees/${id}`);
  }

  async getStudent(studentId: number): Promise<Student> {
    const response = await HttpService.getJson<EdudoResponse<Student>>(
      `/v1/Students/${studentId}`
    );

    return response.data;
  }

  createNewStudent(data: ManagementStudentData) {
    return HttpService.postJson('/v1/Students', getFormatedStudentData(data));
  }

  updateStudent(data: ManagementStudentData, studentId: number) {
    return HttpService.putJson(`/v1/Students/${studentId}`, getFormatedStudentData(data));
  }

  deleteStudent(id: number) {
    return HttpService.delete(`/v1/Students/${id}`);
  }
}